@if (mobileMenuOpen) {
  <button type="button" class="layout-mobile-backdrop" aria-label="Cerrar menú" (click)="closeMobileMenu()"></button>
}

<div class="layout-shell">
  <div class="layout-app" [class.layout-app--mobile-menu-open]="mobileMenuOpen">
    <header class="layout-mobile-header">
      <button
        type="button"
        class="layout-mobile-header__action"
        aria-label="Abrir menú"
        (click)="toggleMobileMenu()">
        <fa-icon [icon]="['fal', 'bars']"></fa-icon>
      </button>

      <img
        class="layout-mobile-header__logo"
        src="assets/images/avalservi.png"
        alt="Avalservi"
        width="103"
        height="64" />

      <span class="layout-mobile-header__spacer" aria-hidden="true"></span>
    </header>

    <div class="layout-app__body">
      <app-sidebar
        class="layout-app__sidebar"
        [collapsed]="siderCollapsed"
        [mobileOpen]="mobileMenuOpen"
        [items]="navItems"
        [userInitial]="userData.initial || 'U'"
        [userName]="userData.name || 'Usuario'"
        userRole="Administrador"
        (navClick)="onSidebarNavClick()"
        (collapseToggle)="toggleSidebar()"
        (logoutClick)="onLogout()" />

      <div class="layout-app__main">
        <main class="layout-app__content" #content>
          <div class="layout-app__view" [class.layout-app__view--fade-in]="viewFadeIn()">
            <router-outlet />
          </div>
        </main>

        <app-footer [text]="shell.footerText" />
      </div>
    </div>
  </div>
</div>
